/**
 * Karşılaştırma: rakip adı vermeden, derneğin bugün kullandığı üç yaygın
 * çözümle. İddialar yalnızca kendi ürünümüz için; diğer sütunlar genel
 * kategorilerin tipik durumunu anlatır.
 */
export type Hucre = true | false | 'kismi'

export interface KarsilastirmaSatiri {
  ozellik: string
  excel: Hucre
  masaustu: Hucre
  ajans: Hucre
  biz: Hucre
  not?: string
}

export const SUTUNLAR = [
  'Excel ve WhatsApp',
  'Masaüstü dernek programı',
  'Web sitesi ajansı',
  'Akıllı Dernek',
]

export const SATIRLAR: KarsilastirmaSatiri[] = [
  {
    ozellik: 'Üye kaydı ve başvuru akışı',
    excel: 'kismi',
    masaustu: true,
    ajans: false,
    biz: true,
  },
  {
    ozellik: 'Aidat borçlandırma ve hatırlatma',
    excel: false,
    masaustu: true,
    ajans: false,
    biz: true,
  },
  {
    ozellik: 'Kartla online ödeme',
    excel: false,
    masaustu: 'kismi',
    ajans: 'kismi',
    biz: true,
    not: 'Her planda dahil, eklenti değil',
  },
  {
    ozellik: 'Üye kendi borcunu görür ve öder',
    excel: false,
    masaustu: false,
    ajans: false,
    biz: true,
  },
  {
    ozellik: 'Web sitesi ve içerik yönetimi',
    excel: false,
    masaustu: false,
    ajans: true,
    biz: true,
  },
  {
    ozellik: 'Kendi alan adı ve otomatik sertifika',
    excel: false,
    masaustu: false,
    ajans: 'kismi',
    biz: true,
  },
  {
    ozellik: 'Kongre: konaklama, transfer, QR kapı',
    excel: false,
    masaustu: false,
    ajans: false,
    biz: true,
  },
  {
    ozellik: 'Online genel kurul ve oylama',
    excel: false,
    masaustu: false,
    ajans: false,
    biz: true,
  },
  {
    ozellik: 'Kurul, toplantı ve karar kaydı',
    excel: 'kismi',
    masaustu: 'kismi',
    ajans: false,
    biz: true,
  },
  { ozellik: 'Gelir-gider ve bütçe', excel: 'kismi', masaustu: true, ajans: false, biz: true },
  { ozellik: 'Roller ve izinler', excel: false, masaustu: 'kismi', ajans: false, biz: true },
  { ozellik: 'Kim neyi değiştirdi kaydı', excel: false, masaustu: false, ajans: false, biz: true },
  {
    ozellik: 'Her yerden, her cihazdan erişim',
    excel: 'kismi',
    masaustu: false,
    ajans: true,
    biz: true,
  },
  { ozellik: 'Otomatik yedek', excel: false, masaustu: 'kismi', ajans: 'kismi', biz: true },
  {
    ozellik: 'Veriyi dışa aktarıp ayrılabilme',
    excel: true,
    masaustu: 'kismi',
    ajans: 'kismi',
    biz: true,
  },
]
